import type { TranslateDescriptionRequest } from '@pulsify/shared/dto'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { QueryKey, queryKey } from '~/shared/lib/query-keys'
import { translateApi } from '../api'

export function useTranslateDescription(businessId: string) {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: (request: TranslateDescriptionRequest) =>
      translateApi.description(businessId, request),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKey(QueryKey.CREDITS_BALANCE, businessId),
      })
    },
  })
}
